import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import style from './style/zaptic-radio-style'
import normalize from './style/normalize-style'

export enum Events {
    onSelected = 'onSelected',
}

export interface CustomEventPayload {
    [Events.onSelected]: string | number
}

@customElement('zaptic-radio')
export class Radio extends LitElement {
    static styles = [style, normalize]

    @property({ type: Boolean })
    selected: boolean
    @property({ type: Boolean })
    disabled: boolean
    @property()
    groupName: string
    @property()
    label?: string
    @property()
    detail?: string
    @property()
    value: string | number

    private onInputSelected() {
        this.dispatchEvent(
            new CustomEvent<CustomEventPayload['onSelected']>(Events.onSelected, {
                detail: this.value,
            })
        )
    }

    render() {
        return html`
            <label class="container">
                <input
                    type="radio"
                    name=${this.groupName}
                    .checked=${this.selected}
                    ?disabled=${this.disabled}
                    @change=${() => this.onInputSelected()}
                    value=${this.value}
                    id=${this.groupName + this.value}
                />
                <div class="description">
                    <span class="title">${this.label}</span><br />
                    <span class="detail">${this.detail}</span>
                </div>
            </label>
        `
    }
}
